export const MessageQueryKeys = {
    all: ['conversation'],
    conversation_ids: () => [...MessageQueryKeys.all, 'conversation'],
    messages: () => [...MessageQueryKeys.all, 'message'],
    conversation_id: (id: number) => [...MessageQueryKeys.conversation_ids(), id],
    message: (id: number) => [...MessageQueryKeys.messages(), id],
  };
  